module.exports = __webpack_public_path__ + "static/chatbot_builder_sec_7-ebedb265b3a0e718c35b423354c2a351.png";